<!--
 * @Description  : 优惠券-赠送记录
 -->
<template>
	<div class="fund_manage couponBox">
		<a-card title="赠送记录" :bordered="false">
			<!-- 搜索 -->
			<div class="search">
				<a-form layout="inline" :form="form">
					<a-form-item>
						<a-select @change="changeIs" v-decorator="['coupon_type', { initialValue: coupon_type}]" allowClear placeholder="请选择优惠券状态" style="width: 195px">
							<a-select-option :value="0">未使用</a-select-option>
							<a-select-option :value="2">已使用</a-select-option>
							<a-select-option :value="3">已过期</a-select-option>
						</a-select>
					</a-form-item>
			
					<a-form-item>
						<a-input @change="changeUser" v-decorator="['user_id', { initialValue: user_id}]" allowClear style="width:240px;" placeholder="请输入会员ID/会员名称/手机号"/>
					</a-form-item>

                    <a-form-item>
						<a-input @change="changeSno" v-decorator="['order_sNo', { initialValue: order_sNo}]" allowClear style="width:240px;" placeholder="请输入订单编号"/>
					</a-form-item>

					<a-form-item><a-button @click="resetGoods">重置</a-button></a-form-item>
			
					<a-form-item><a-button type="primary" html-type="submit" @click="query">查询</a-button></a-form-item>
				</a-form>
			</div>
			
			<!-- 表格 -->
			<a-table
				:loading="loading"
				:columns="columns"
				:dataSource="dataSource"
				:row-key="record => record.id"
				:pagination="pagination"
				@change="onChangeload"
			>
				<span slot="imgurl" slot-scope="text"><img :src="text.imgurl" class="table-imgurl" /></span>
			
				<span slot="status" slot-scope="text">
					<a-tag v-if="text == 2" color="#8BC34A">已上架</a-tag>
					<a-tag v-else-if="text == 3" color="#969DA8">已下架</a-tag>
					<a-tag v-else color="#969DA8">待上架</a-tag>
				</span>
				
				<span slot="type" slot-scope="text">
					{{text==3?'已过期':text==0?'未使用':text==2?'已使用':''}}
				</span>
			
				<span slot="action" slot-scope="text">
					<div style="display: flex;flex-direction: column;">
						<a class="sNo" href="javascript:;" @click="toOrder(item)" v-for="item,index of text.sNo_list" :key="index">
                            {{item}}
                        </a>
					</div>
				</span>
			</a-table>
		</a-card>
		
		<!-- 导出 -->
		<a-modal v-model="visible1" title="导出数据" :footer="null" width="540px">
			<div class="derive">
				<div @click="onDownload('This_page')">
					<a-icon type="file-text" style="font-size:26px;" />
					<div>导出本页</div>
				</div>
		
				<div @click="onDownload('whole')">
					<a-icon type="snippets" style="font-size:26px;" />
					<div>导出全部</div>
				</div>
		
				<div @click="onDownload('inquiry')">
					<a-icon type="file-search" style="font-size:26px;" />
					<div>导出查询</div>
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
const columns = [
	{
		title: '会员ID',
		key: 'user_id',
		dataIndex: 'user_id'
	},
	{
		title: '会员名称',
		key: 'user_name',
		dataIndex: 'user_name'
	},
	{
		title: '手机号',
		key: 'mobile',
		dataIndex: 'mobile'
	},
	{
		title: '面值',
		key: 'face_value',
		dataIndex: 'face_value'
	},
	{
		title: '状态',
		key: 'type',
		dataIndex: 'type',
		scopedSlots: { customRender: 'type' }
	},
	{
		title: '赠送时间',
		key: 'add_date',
		dataIndex: 'add_date'
    },
    {
		title: '到期时间',
		key: 'expiry_time',
		dataIndex: 'expiry_time'
    },
    {
		title: '关联订单号',
		scopedSlots: { customRender: 'action' }
	},
	// {
	// 	title: '操作',
	// 	key: 'action',
	// 	scopedSlots: { customRender: 'action' }
	// }
];

export default {
	data() {
		return {
			columns,
			form: this.$form.createForm(this, { name: 'deliver' }), // 搜索form
			activeKey: "1",

			// 搜索
			is_use: undefined,
			user_id: '',

			// 表格
			loading: true,
			selectedRowKeys: [],
			selectedRow: [],
			dataSource: [{
				id: 1,
				name: '满100减20',
				type: '满减',
				scope: '全部商品',
				threshold: '满100',
				money: '20元',
				num: 10,
				inventory: 10,
				status: 1,
				valid_time: '2020.08.01-2020.08.08',
			}],
			pagination: {},
			
			// 导出
			visible1: false,
			urls: '',
			
            couponid: '',
            coupon_type: undefined,
            order_sNo: '',
            searchData: {}
		};
	},
	created() {
		this.couponid = this.$route.params.id
		this.getList()
	},
	methods: {
		toOrder(id){
			console.log(id)
			this.$router.push({ path: "/ordermanage/details/" + id });
		},
		changeIs(e){
			this.coupon_type = e
		},
		changeUser(e){
			this.user_id = e.target.value
		},
		changeSno(e){
			this.order_sNo = e.target.value
		},
		/**
		 * @name 导出
		 */
		onDownload(pageto) {
			this.visible1 = false
			
			if (pageto != 'whole') {
				this.form.validateFields((err, values) => {
					if (!err) {
						values.name = values.user_id
						values.status = values.is_use
						let data = { ...values , page: this.pagination.current};
						this.$request.download(this.urls + pageto, data);
					}
				});
				return;
			}
			
			this.$request.download(this.urls + pageto);
		},
		/**
		 * @name 导出
		 * */
		
		download(refnamm) {
			this.urls = refnamm;
			this.visible1 = !this.visible1;
		},
		/**
		 * @name 路由跳转
		 */
		onNavJump(url){
		  this.$router.push(url)
		},
		resetGoods() {
			this.coupon_type = undefined
            this.user_id = ''
            this.order_sNo = ''
			
			this.form.setFieldsValue({
				coupon_type: undefined,
                user_id: '',
                order_sNo: ''
			});
		},
		onSelectChange(selectedRowKeys, selectedRow) {
			this.selectedRowKeys = selectedRowKeys;
			this.selectedRow = selectedRow;
		},
		onChangeload(pagination) {
			this.getList({ page: pagination.current, ...pagination });
        },
        query(){
            this.searchData = {
                sNo: this.order_sNo,
                user_id: this.user_id,
                type: this.coupon_type
			}
			console.log(this.searchData)
            this.getList()
        },
		/**
		 * @name 请求列表
		 */
		getList(page = {}, current = 1) {
			this.loading = true;

			let data = {
				id: this.$route.params.id,
				...this.searchData,
				...page
			};
			let url = '?module=pc_api&action=coupon&app=GiftSee';

			this.$request.post(url, data).then(res => {
				let { code, message, data } = res;
				if(code == 200){
					this.dataSource = data.list
					
					let pages = {
					  total: data.total ,
					  current: page.page || current
					}
					this.pagination = pages
				}else{
					this.$message.error(message)
				}
				
				this.loading = false
			});
		}
	}
};
</script>
<style lang="less">
.fund_manage {
	position: relative;
	min-height: 100%;
	.search {
		padding: 8px 32px;
	}

	.handle {
		padding: 0px 32px;
		padding-bottom: 8px;
		display: flex;
		align-items: center;
	}
	
	.ant-card-body{
		padding: 0
	}
}
.derive {
  height: 200px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  > div {
    width: 100px;
    height: 100px;
    border: 1px solid #03a2f4;
    border-radius: 4px;
    color: #03a2f4;
    font-size: 14px;
    transition: background-color 0.5s;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-evenly;
    cursor: pointer;
  }

  > div:hover {
    border: 0px solid #03a2f4;
    color: #ffffff;
    background: #2890ff;
  }
}

.ant-card-wider-padding .ant-card-head{
    padding: 0 22px;
}

.couponBox[class]{
	
	.ant-tabs-top-bar{
		margin-bottom: 0;
	}
	
	.search{
		padding: 20px;
		
		.ant-form{
			display: flex;
			
			.ant-form-item{
				margin-right: 8px;
			}
			
			.ant-btn{
				width: 56px;
				padding: 0;
			}
		}
	}
	
	.handle{
		padding: 0 20px 20px;
		
		.ant-btn{
			
		}
    }
    
    .ant-btn{
		font-size: 14px;
		font-family: Microsoft YaHei;
		color: #323544;
		background: #FFFFFF;
		border: 1px solid #828B97;
	}
	
	.ant-btn-primary[class]{
		color: #FFFFFF;
		background-color: #323544;
    }
    
    .ant-form{
        display: flex;
        align-items: center;
        height: 32px;
    }

    .ant-table-pagination.ant-pagination{
        margin-right: 20px;
    }
}

.sNo{
    color: #1E202C;
}

.sNo:hover{
    color: #03A2F4;
    text-decoration: underline;
}
</style>
